import { useState, useEffect } from 'react';
import { client } from '../sanity/client';

export function useProjects() {
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [hiddenProjects, setHiddenProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        console.log('Fetching projects for portfolio...');
        client
            .fetch(`*[_type == "careerEvent" && type == "project"] | order(monthIndex desc) {
        _id,
        title,
        type,
        projectTypes,
        monthIndex,
        color,
        description,
        image,
        "imageExtension": image.asset->extension,
        "imageUrl": image.asset->url,
        "imageGallery": images[],
        detailedDescription[] {
          ...,
          _type == "image" => {
            ...,
            "url": asset->url
          },
          _type == "imageCarousel" => {
            ...,
            images[] {
              ...,
              "url": asset->url
            }
          },
          _type == "video" => {
            ...,
            "url": file.asset->url
          }
        },
        techStack,
        outcomes,
        links,
        endMonthIndex,
        isFeatured
      }`)
            .then(projects => {
                console.log('Projects received:', projects);

                // Check if any projects are manually featured
                const manuallyFeatured = projects.filter(p => p.isFeatured === true);

                let selected, hidden;

                if (manuallyFeatured.length > 0) {
                    // Use manually featured projects
                    selected = manuallyFeatured;
                    hidden = projects.filter(p => !p.isFeatured);
                } else {
                    // Fallback to 6 most recent projects (already sorted desc)
                    selected = projects.slice(0, 6);
                    hidden = projects.slice(6);
                }

                console.log('Selected projects:', selected);
                console.log('Hidden projects:', hidden);

                setSelectedProjects(selected);
                setHiddenProjects(hidden);
                setLoading(false);
            })
            .catch(err => {
                console.error('Error fetching projects:', err);
                setLoading(false);
            });
    }, []);

    return { selectedProjects, hiddenProjects, loading };
}
